import {translate} from 'views/module';

const generateFilterOptions = () => {
  const filterOptions = {};

  filterOptions.status = {
    key: 'status',
    label: translate('clientLead.ClientLeadList.Filter.Status'),
    rank: 1,
    options: Object.entries(translate('clientLead.Status'))
        .reduce((acc, [key, value], index) => {
          acc[key] = {
            label: value.Title,
            rank: index,
            key: key,
          };
          return acc;
        }, {}),
    canBeEmpty: false,
  };


  return filterOptions;
};

export {
  generateFilterOptions,
};
